import React from "react";
import { Download, FileSpreadsheet, ExternalLink } from "lucide-react";
import "./PaieCyclePages.css";

export default function TeledeclarationFiscalesPage() {
    const handleDownload = () => {
        const link = document.createElement("a");
        link.href = "/assets/etat_edi.xlsx";
        link.download = "etat_edi.xlsx";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const handleGoToSimplIR = () => {
        window.open("https://irpart.tax.gov.ma/simplir_part/private/login.do?method=reload&feature=IR&langue=fr", "_blank", "noopener,noreferrer");
    };

    const btnPrimary = { background: "#204385", color: "#fff", border: "none" };
    const btnSecondary = { background: "#ee645f", color: "#fff", border: "none" };

    return (
        <div className="pcyc-page">
            <div className="pcyc-header">
                <div>
                    <h2><FileSpreadsheet size={18} /> Télédéclarations fiscales (EDI 9421)</h2>
                    <p>Téléchargement de l'état EDI 9421 et dépôt sur la plateforme de la DGI Simpl-IR.</p>
                </div>
            </div>

            <div className="pcyc-grid">
                <section className="pcyc-card" style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: "40px", gap: "20px" }}>
                    <div style={{ background: "#e8edf7", color: "#204385", borderRadius: "50%", padding: "20px" }}>
                        <FileSpreadsheet size={48} />
                    </div>
                    <div style={{ textAlign: "center", maxWidth: "600px" }}>
                        <h3>Télédéclaration EDI 9421</h3>
                        {/*<p style={{ color: "#6b7280", fontSize: "13px", marginTop: "8px", lineHeight: "1.6" }}>*/}
                        {/*    Étape 1 : Téléchargez le fichier Excel de télédéclaration pré-rempli au format EDI 9421.<br />*/}
                        {/*    Étape 2 : Cliquez sur le bouton d'accès au portail <strong>Simpl-IR</strong> pour vous connecter et déposer le fichier téléchargé.*/}
                        {/*</p>*/}
                    </div>
                    <div style={{ display: "flex", gap: "16px", flexWrap: "wrap", marginTop: "10px" }}>
                        <button className="pcyc-btn" style={{ ...btnPrimary, padding: "12px 24px", fontSize: "14px" }} type="button" onClick={handleDownload}>
                            <Download size={18} /> Télécharger l'état EDI 9421
                        </button>
                        <button className="pcyc-btn" style={{ ...btnSecondary, padding: "12px 24px", fontSize: "14px" }} type="button" onClick={handleGoToSimplIR}>
                            <ExternalLink size={18} /> Accéder à Simpl-IR (DGI)
                        </button>
                    </div>
                </section>
            </div>
        </div>
    );
}
